import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { ITerminalResponse } from '../models/terminal.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Gets a list of terminals
 * 
 * @retuns {object} the api response
 */
export const getTerminals = async (): Promise<ITerminalResponse> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get('/terminal',  {
      params: {
        'wpID': userId
      }
    });

    return data;    
  } catch ( error ) {
    handleRouteError(error, 'Error getting terminal list');
    throw(error);
  }
}